import { IGamesState } from './gamesContext';
import { GamesActionTypes, TGamesAction } from './gamesActions';

export const gamesReducer = (state: IGamesState, action: TGamesAction): IGamesState => {
	switch (action.type) {
		case GamesActionTypes.SET_GAMES:
			return {
				...state,
				games: action.payload.games,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case GamesActionTypes.CHANGE_SEARCH_STRING:
			return {
				...state,
				searchString: action.payload.searchString,
				currentPage: 1,
			};
		case GamesActionTypes.SET_DEVELOPER:
			return {
				...state,
				selectedDeveloper: action.payload.selectedDeveloper,
				isUnassignedGames: false,
				currentPage: 1,
			};
		case GamesActionTypes.SET_CATEGORY:
			return {
				...state,
				selectedCategory: action.payload.selectedCategory,
				isUnassignedGames: false,
				currentPage: 1,
			};
		case GamesActionTypes.RESET_SELECTED_CONTROLS:
			return {
				...state,
				searchString: '',
				selectedDeveloper: null,
				selectedCategory: null,
				isUnassignedGames: false,
				currentPage: 1,
			};
		case GamesActionTypes.TOGGLE_UNASSIGNED_GAMES:
			return {
				...state,
				isUnassignedGames: !state.isUnassignedGames,
				currentPage: 1,
			};
		case GamesActionTypes.SET_SORT_BY:
			return {
				...state,
				sortBy: action.payload.sortBy,
				currentPage: 1,
			};
		case GamesActionTypes.SET_COUNT_OF_ITEMS:
			return {
				...state,
				countOfItems: action.payload.countOfItems,
				currentPage: 1,
			};
		case GamesActionTypes.CHANGE_CURRENT_PAGE:
			return {
				...state,
				currentPage: action.payload.currentPage,
			};
		case GamesActionTypes.SET_ID_FOR_DELETION:
			return {
				...state,
				IDForDeletion: action.payload.IDForDeletion,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case GamesActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case GamesActionTypes.SET_FILTERS_FROM_QUERY_STRING:
			return {
				...state,
				...action.payload.filters,
			};
		default:
			return state;
	}
};
